import Head from "next/head";
import { Fragment } from "react";

function SharedCompanyHeader(props) {
  const country =
    process.env.NEXT_PUBLIC_JSW_GEOLOCATION === "sg" ? "Singapore" : "Malaysia";

  // Checks company name to exclude trailing words
  let companyNameInput = props.company?.name;
  let excludedWords = [
    "sdn. bhd.",
    "sdn bhd",
    "sendirian bhd",
    "sdn berhad",
    "sendirian berhad",
  ];
  let regex = new RegExp("\\b(" + excludedWords.join("|") + ")\\b", "gi");
  let companyName = companyNameInput.replace(regex, "").trim();

  let metaTitle =
    props.company == undefined
      ? "Company Profile & Information | Hiredly Malaysia"
      : props.company?.id === "750524cc-6b5d-48c8-8438-0b5b1c3f6aea" // Hiredly X
      ? "Let our headhunters find you a job in Malaysia | Hiredly X"
      : `${companyName} | Hiredly ${country}`;

  let metaDescription =
    props.company == undefined
      ? "Learn about the work environment, culture, benefits & job opportunities here. View office location, employee experience, and start your career right."
      : props.company?.id === "750524cc-6b5d-48c8-8438-0b5b1c3f6aea" // Hiredly X
      ? "View jobs in Malaysia our headhunters are recruiting for | Hiredly X"
      : `Learn about ${companyName}'s work environment, culture, benefits & job opportunities here.`;

  return (
    <Fragment>
      <Head>
        {/* <!-- Primary Meta Tags --> */}
        <title>{metaTitle}</title>
        <meta property="" content="initial-scale=1.0, width=device-width" />
        <meta name="title" content={metaTitle} />
        <meta name="description" content={metaDescription} />

        {/* <!-- Open Graph / Facebook --> */}
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://my.hiredly.com/companies/${props.company?.slug}`}
        />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:image" content={props.company?.cover_image_thumb} />

        {/* <!-- Twitter --> */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content={`https://my.hiredly.com/companies/${props.company?.slug}`}
        />
        <meta property="twitter:title" content={metaTitle} />
        <meta property="twitter:description" content={metaDescription} />
        <meta
          property="twitter:image"
          content={props.company?.cover_image_thumb}
        />
        <link
          rel="canonical"
          href={`https://my.hiredly.com/companies/${props.company?.slug}`}
        />
      </Head>
    </Fragment>
  );
}

export default SharedCompanyHeader;
